import Button from "../../commons/button";
import Input from "../../commons/input";
import Select from "../../commons/select";
import icTrash01Red from "../../../assets/images/ic-trash-01-red.svg";
import icDocumentUploadPrimary from "../../../assets/images/ic-document-upload-primary.svg";
import icFileCheck from "../../../assets/images/ic-file-check-02.svg";
import { Alert } from "../../commons/alert";
import { StandardModal } from "../../commons/StandardModal";
import { onOpenFile } from "../../../utils/utils";

export const SopForm = ({
    isEdit,
    formValue,
    onChangeValue,
    categoryOptions,
    onSearchCategory,
    employeeOptions,
    employeeTypeOptions,
    onSearchEmployee,
    onSearchEmployeeType,
    file,
    onUploadFile,
    onDeleteFile,
    additionalLinks,
    onAddLink,
    onRemoveLink,
    onChangeLinkValue,
    onSaveDraft,
    onSubmitForm,
    isLoadingSave,
    isLoadingSubmit,
    errorForm,
    confirmModal,
    onCloseConfirmModal,
    onConfirmAction,
}) => {
    const handleUpload = (e) => {
        const selectedFile = e.target?.files[0]
        if (!selectedFile) return

        const allowedExtensions = /(\.pdf)$/i
        if (!allowedExtensions.exec(selectedFile?.name)) {
            e.target.value = null
            return Alert({
                icon: 'error',
                title: 'Failed',
                message: 'File harus berformat PDF',
            })
        }

        if (selectedFile?.size > 21000000) {
            e.target.value = null
            return Alert({
                icon: 'error',
                title: 'Failed',
                message: 'File terlalu besar (Maksimal 20 MB)',
            })
        }

        onUploadFile(selectedFile)
        e.target.value = null
    }

    const isLoading = isLoadingSave || isLoadingSubmit

    const fileName =
        typeof file === 'string'
            ? file.split('/').pop() || 'SOP Document'
            : file?.name || 'SOP Document'

    return (
        <div className={`flex flex-col ${isLoading ? 'pointer-events-none' : ''}`}>
            <div className="px-6 py-4 border-b">
                <p className="font-semibold text-lg text-neutral-80">
                    {isEdit ? 'Edit SOP' : 'Create SOP'}
                </p>
            </div>
            <div className="flex flex-col px-6 py-6 gap-[20px] max-w-[800px]">
                {/* SOP Name */}
                <div className="flex flex-row items-center">
                    <div className="w-1/3 text-neutral-70 required">SOP Name</div>
                    <div className="flex-1">
                        <Input
                            name="name"
                            placeholder="Masukkan nama SOP"
                            value={formValue?.name}
                            onChange={onChangeValue}
                        />
                        {errorForm?.name && (
                            <p className="text-red-50 text-sm mt-1">{errorForm.name}</p>
                        )}
                    </div>
                </div>

                {/* SOP Number */}
                <div className="flex flex-row items-center">
                    <div className="w-1/3 text-neutral-70 required">SOP Number</div>
                    <div className="flex-1">
                        <Input
                            name="number"
                            placeholder="Masukkan nomor SOP"
                            value={formValue?.number}
                            onChange={onChangeValue}
                        />
                        {errorForm?.number && (
                            <p className="text-red-50 text-sm mt-1">{errorForm.number}</p>
                        )}
                    </div>
                </div>

                {/* SOP Category */}
                <div className="flex flex-row items-center">
                    <div className="w-1/3 text-neutral-70 required">SOP Category</div>
                    <div className="flex-1">
                        <Select
                            name="category"
                            placeholder="Pilih Category"
                            options={categoryOptions}
                            value={formValue?.category}
                            onChange={onChangeValue}
                            onSearch={onSearchCategory}
                            optionsClassName="max-h-[250px]"
                        />
                        {errorForm?.category && (
                            <p className="text-red-50 text-sm mt-1">{errorForm.category}</p>
                        )}
                    </div>
                </div>

                {/* Upload File */}
                <div className="flex flex-row items-start">
                    <div className="w-1/3 text-neutral-70 required pt-2">Upload File</div>
                    <div className="flex-1">
                        <div className="flex flex-col gap-2">
                            {file ? (
                                <div className="flex items-center gap-3 p-3 border border-neutral-30 rounded-lg bg-neutral-10">
                                    <img src={icDocumentUploadPrimary} alt="file" className="w-5 h-5" />
                                    <span className="flex-1 text-sm text-neutral-80 truncate">
                                        {fileName}
                                    </span>
                                    {typeof file === 'string' && (
                                        <button
                                            type="button"
                                            className="text-primary-50 text-sm font-medium hover:underline"
                                            onClick={() => onOpenFile({ urls: [file] }, 'SOP-File')}
                                        >
                                            View
                                        </button>
                                    )}
                                    <button
                                        type="button"
                                        className="text-red-50 text-sm font-medium"
                                        onClick={onDeleteFile}
                                    >
                                        Remove
                                    </button>
                                </div>
                            ) : (
                                <label className="flex flex-col items-center gap-2 p-6 border-2 border-dashed border-neutral-30 rounded-lg cursor-pointer hover:border-primary-50 transition-colors">
                                    <img src={icDocumentUploadPrimary} alt="upload" className="w-8 h-8" />
                                    <span className="text-sm text-neutral-50">
                                        Klik untuk upload file PDF
                                    </span>
                                    <span className="text-xs text-neutral-40">
                                        Maksimal 20 MB
                                    </span>
                                    <input
                                        type="file"
                                        accept=".pdf"
                                        className="hidden"
                                        onChange={handleUpload}
                                    />
                                </label>
                            )}
                        </div>
                        {errorForm?.file && (
                            <p className="text-red-50 text-sm mt-1">{errorForm.file}</p>
                        )}
                    </div>
                </div>

                {/* Additional Links - Optional */}
                <div className="flex flex-row items-start">
                    <div className="w-1/3 text-neutral-70 pt-2">Additional Links</div>
                    <div className="flex-1 flex flex-col gap-3">
                        {additionalLinks?.map((link, index) => (
                            <div key={index} className="flex flex-col gap-2 p-3 border border-neutral-30 rounded-lg">
                                <div className="flex items-center justify-between">
                                    <span className="text-sm font-medium text-neutral-60">Link {index + 1}</span>
                                    {additionalLinks.length > 1 && (
                                        <button type="button" onClick={() => onRemoveLink(index)}>
                                            <img src={icTrash01Red} alt="remove" className="w-4 h-4" />
                                        </button>
                                    )}
                                </div>
                                <Input
                                    name={`link_name_${index}`}
                                    placeholder="Masukkan nama link"
                                    value={link?.name}
                                    onChange={(e) => onChangeLinkValue(index, 'name', e?.value)}
                                />
                                {errorForm?.[`link_name_${index}`] && (
                                    <p className="text-red-50 text-sm">{errorForm[`link_name_${index}`]}</p>
                                )}
                                <Input
                                    name={`link_url_${index}`}
                                    placeholder="Masukkan URL link"
                                    value={link?.url}
                                    onChange={(e) => onChangeLinkValue(index, 'url', e?.value)}
                                />
                                {errorForm?.[`link_url_${index}`] && (
                                    <p className="text-red-50 text-sm">{errorForm[`link_url_${index}`]}</p>
                                )}
                            </div>
                        ))}
                        <Button
                            type="outline"
                            title="Tambah Link"
                            onClick={onAddLink}
                            className="w-fit"
                        />
                    </div>
                </div>

                {/* Employee Name */}
                <div className="flex flex-row items-center">
                    <div className="w-1/3 text-neutral-70">Employee Name</div>
                    <Select
                        name="employees"
                        className="flex-1"
                        placeholder="Pilih Employee"
                        options={employeeOptions}
                        value={formValue?.employees}
                        onChange={onChangeValue}
                        onSearch={onSearchEmployee}
                        optionsClassName="max-h-[250px]"
                        isMultiple
                    />
                </div>

                {/* Employee Type */}
                <div className="flex flex-row items-center">
                    <div className="w-1/3 text-neutral-70">Employee Type</div>
                    <Select
                        name="employee_types"
                        className="flex-1"
                        placeholder="Pilih Employee Type"
                        options={employeeTypeOptions}
                        value={formValue?.employee_types}
                        onChange={onChangeValue}
                        onSearch={onSearchEmployeeType}
                        optionsClassName="max-h-[250px]"
                        isMultiple
                    />
                </div>
            </div>

            {/* Form Actions */}
            <div className="px-6 py-4 flex justify-end gap-3 border-t">
                <Button
                    type="outline"
                    title="Save as Draft"
                    onClick={onSaveDraft}
                    loading={isLoadingSave}
                    disabled={!formValue?.name || !formValue?.name?.trim()}
                    className="px-8"
                />
                <Button
                    title="Submit"
                    onClick={onSubmitForm}
                    loading={isLoadingSubmit}
                    className="px-8"
                />
            </div>

            {/* Confirmation Modal */}
            <StandardModal
                show={confirmModal?.show}
                onHide={onCloseConfirmModal}
                text={confirmModal?.text}
                icon={icFileCheck}
                isLoading={isLoadingSave || isLoadingSubmit}
                onSubmit={onConfirmAction}
                confirmText={confirmModal?.confirmText || 'Lanjutkan'}
            />
        </div>
    );
};
